<template>
  <div>
    <builderall-appshell v-if="!notShowWrapper.includes(this.$route.name)" :token="getOfficeToken()"
      tool="website-builder" class="builderall-css">
      <div id="app" class='ba-app-content'>
        <builderall-banner 
          title='Builderall Website Builder' 
          :subtitle="$t('ct-banner-subtitle')"
          :description="$t('ct-banner-description')" 
        />

        <div class='ba-app-wrapper ba-gp-1'>
          <Sidebar />

          <router-view />
          <vue-snotify></vue-snotify>

          <digital-file-repository
            ref="digitalFileRepository"
            :show="showDigitalFileRepository"
            :accept="accept"
            :saveFile="saveFile"
            :closeFile="closeFile"
            class="digital-file-repository"
          ></digital-file-repository>

          <div class='ba-footer'>
            <builderall-footer></builderall-footer>
          </div>
        </div>
      </div>
    </builderall-appshell>
    <div v-else id="app">
      <vue-snotify></vue-snotify>
      <router-view />
      <div class="modal-loading-overlay">
        <div class="loader-spinna"></div>
      </div>
      <digital-file-repository
          ref="digitalFileRepository"
          :show="showDigitalFileRepository"
          :accept="accept"
          :saveFile="saveFile"
          :closeFile="closeFile"
          class="digital-file-repository"
        ></digital-file-repository>
    </div>
  </div>
</template>

<script>
import { getUser } from './js/services/user';
import ModalFiles from './components/general/FilesManager/FileManager';
import Sidebar from './components/general/Sidebar.vue';
import DigitalFileRepository from './components/general/FilesManager/DigitalFileRepository';
import {mapGetters} from "vuex";

export default {
  name: 'App',
  components: {
    ModalFiles,
    Sidebar,
    DigitalFileRepository
  },
  data() {
    return {
      title: 'Website Builder',
      accept: 'Videos',
      showDigitalFileRepository: false,
      saveFile: () => {},
      closeFile: () => {},
      notShowWrapper: ['editor', 'editor-layout-item', 'editor-default-item', 'Redirector', 'RedirectElearning', 'CheetahRedirectorPage', 'Login', 'PublicLinkSave']
    };
  },
  watch: {
    $route: function (current, old) {
      try {
        this.addOrRemoveBuilderallCss();
      } catch (e) {
        console.error(e);
      }
    },
  },
  methods: {
    ...mapGetters({ getOfficeToken: 'getOfficeToken' }),
    addOrRemoveBuilderallCss() {
      const lib = {
        io: 'https://css.kub.app.builderall.io/builderall.css',
        info: 'https://css.kub.app.builderall.info/builderall.css',
        com: 'https://css.builderall.com/builderall.css'
      }
      const env = window.location.host.includes('.com') ? 'com' : (window.location.host.includes('.info') ? 'info' : 'io')
      const urlStyle = lib[env]
      const linkRel = document.getElementById('link-builderall-css')
      if (!this.notShowWrapper.includes(this.$route.name)) {
        if (linkRel) {
          return
        }

        // Adiciona css style
        var link = document.createElement('link');
        link.rel = "stylesheet";
        link.id = "link-builderall-css";
        link.type = "text/css";
        link.href = urlStyle;
        document.head.appendChild(link);

      } else if (linkRel) {
        // remove style css
        linkRel.remove()
      }
    },
    getLangFormat() {
      let languagesValid = ['ar-ar', 'da-da', 'de-de', 'el-el', 'en-us', 'es-es', 'fa-fa',
        'fr-fr', 'he-il', 'hi-hi', 'hu-hu', 'it-it', 'ja-jp', 'pl-pl',
        'pt-br', 'ro-ro', 'ru-ru', 'si-si', 'sk-sk', 'th-th', 'tr-tr', 'vi-vi', 'zh-cn'
      ];

      let acceptLang = this.$lang.toLowerCase();

      if (languagesValid.includes(acceptLang)) {
        acceptLang = acceptLang.split('-');
        acceptLang[1] = acceptLang[1].toUpperCase();
        acceptLang = acceptLang.join('_');

        window.setCookie('languageEditorUser', acceptLang);

        return acceptLang;
      }
    }
  },
  created() {
    var vm = this;

    this.$root.$on('fileMananger', (values) => {
      this.accept    = values.type;
      this.saveFile  = values.save;
      this.closeFile = values.close;

      if (values.action == 'open') {
        this.showDigitalFileRepository = true;
      } else {
        this.showDigitalFileRepository = false;
      }
    });

    var login = !!(
      localStorage.getItem('login') && localStorage.getItem('login') === 'true'
    );

    if (login) {
      getUser(this.getOfficeToken())
        .then(({ data }) => {
          if (data.success) {
            let user = data.user;

            this.$translate.seti18n(this.$i18n);
            this.$translate.setLang(user.lang ? user.lang : this.getLangFormat());
            this.$translate.init(user.lang ? user.lang : this.getLangFormat());
            this.$store.commit('user', user);

            window.setCookie('email', user.email);
          }
        })
    }

    this.$root.$on('linkAction', (link) => {
      switch (link.type) {
        case 'web': {
          if (link.value !== '') {
            if (link.target === '_blank') {
              window.open(link.value, '_blank');
            } else {
              window.location.href = link.value;
            }
          }
          break;
        }
        case 'page': {
          pagesConfig.forEach(page => {
            if (link.valueID == page.id) {
              if (link.target === '_blank') {
                window.open('/' + page.url, '_blank');
              } else {
                window.location.href = '/' + page.url;
              }
            }
          });
          break;
        }
        case 'anchor': {
          let pageAnchor = {};
          let anchorName = '';
          pagesConfig.forEach(page => {
            if (typeof page !== 'undefined' && typeof page.configs !== 'undefined') {
              page.configs.forEach(config => {
                if (config.key === 'anchors') {
                  let anchors = JSON.parse(config.value);
                  if (typeof anchors[link.valueID] !== 'undefined') {
                    pageAnchor = page;
                    anchorName = anchors[link.valueID];
                  }
                }
              });
            }
          });
          if (anchorName !== '') { window.location.href = '/' + pageAnchor.url + '#' + anchorName }
          break;
        }
        case 'popup': {
          let vm = this;

          this.userPopups.forEach(popup => {
            if (link.valueID == popup.id) {
              vm.$refs['popup' + popup.id][0].open();
            }
          });
          break;
        }
        case 'video': {
          if (link.value !== '') {
            this.$refs.videoModalIframe.src = link.value;
            this.$refs.videoModalIframeMobile.src = link.value;
            this.$refs.videoModal.open();
          }
          break;
        }

        case 'download': {
          let url = 'https://www.omb11.com/files/downloads';
          window.open(url + '?file_src=' + link.src + '&file_name=' + link.name + '&request=download', '_self');
        }

        case 'telefone': {
          window.open('tel:' + link.tel, '_blank');
          break;
        }
      }
    });
    this.addOrRemoveBuilderallCss()
  }
};
</script>

<style lang="scss">
@import "./assets/sass/_all.scss";
@import "./assets/lib/ba-css/ba-css-custom.scss";

#app {
  -webkit-font-smoothing: antialiased; // faz com que as fontes ficam igual em todos navegadores mac x janelas
  -moz-osx-font-smoothing: grayscale;
  background: #E9EDF2;
  height: auto;

  &.ba-app-content {
    position: absolute;
    width: calc(100% - 54px);
    height: calc(100% - 80px);
  }
}

.navbar {
  box-shadow: 0px 1px 2px #26242424;
  border: 1px solid #DEDEDE;
  opacity: 1;
}

.shadow {
  box-shadow: 0 0 2rem 0 #8898aa26 !important;
}

.btn-edit {
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0;
  color: #F8FAFD;
  min-width: 127px;
  background: #04E2B0;
  box-shadow: 0.62px 0.79px 2px #1E120D1A;
  border-radius: 5px;
  opacity: 1;
  padding: 15px 15px;
}

.digital-file-repository{
  z-index: 99999;
  position: relative;
}

.btn-primary-light {
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0;
  color: #0294FF;
}
</style>



// WEBPACK FOOTER //
// src/App.vue